import { render, staticRenderFns } from "./LpAddPayType.vue?vue&type=template&id=c761afbe&scoped=true"
import script from "./LpAddPayType.vue?vue&type=script&lang=js"
export * from "./LpAddPayType.vue?vue&type=script&lang=js"
import style0 from "./LpAddPayType.vue?vue&type=style&index=0&id=c761afbe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c761afbe",
  null
  
)

export default component.exports